.swap {
  display: grid;
  grid-template-columns: subgrid;
  grid-column: 1 / -1;
}

.swap > * {
  grid-row: 1;
  grid-column: 1 / -1;
  min-width: 0;
}

.out {
  display: grid;
  grid-template-columns: subgrid;
  row-gap: var(--sizes-spacing-10);
  transition: opacity 250ms cubic-bezier(0.14, 0.66, 0.43, 1);
}

.out > * {
  grid-column: 1 / -1;
}

.out[data-motion-state="entering"],
.out[data-motion-state="exiting"] {
  opacity: 0;
}

@media (prefers-reduced-motion: reduce) {
  .out {
    transition: none;
  }
}

:root[data-flyui-skip-animations="true"] .out {
  transition: none;
}
